import { render } from "./SecurityGroupActionsPopover.vue?vue&type=template&id=f90f7a56&ts=true"
import script from "./SecurityGroupActionsPopover.vue?vue&type=script&lang=ts"
export * from "./SecurityGroupActionsPopover.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__